'use strict';

module.exports = function whereNotNull() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return this.where(key, '!==', null);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/whereNotNull.js
// module id = 1747
// module chunks = 2